/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 単価マスタ検索情報
 */
export interface Szza026aRequestTankaMasterSrchInfDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string | null;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string | null;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string | null;
    /**
     * 単価指定区分１コード：数字
     */
    tankaSiteiDiv1?: string | null;
    /**
     * 単価指定区分２コード：数字
     */
    tankaSiteiDiv2?: string | null;
    /**
     * 単価指定区分３：数字
     */
    tankaSiteiDiv3?: string | null;
    /**
     * 単価指定区分４：数字
     */
    tankaSiteiDiv4?: string | null;
    /**
     * 単価指定区分５：数字
     */
    tankaSiteiDiv5?: string | null;
    /**
     * 単価範囲開始値：数字<br>　精度(3)
     */
    tankaRangeStart?: number | null;
    /**
     * 適用開始日付（From）：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付（To）：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
    /**
     * 適用終了日付（From）：日付(yyyyMMdd)
     */
    applyEndDateFrom?: string | null;
    /**
     * 適用終了日付（To）：日付(yyyyMMdd)
     */
    applyEndDateTo?: string | null;
    /**
     * 単価正式名称：全角
     */
    tankaAname?: string | null;
    /**
     * 単価略称名称：全角
     */
    tankaRyaku?: string | null;
    /**
     * 単価範囲終了値：数字<br>　精度(3)
     */
    tankaRangeEnd?: number | null;
    /**
     * 単価：数字<br>　精度(3)
     */
    tanka?: number | null;
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    unitFracCalc?: string | null;
    /**
     * 単位：数字
     */
    unit?: number | null;
}

